<template>
    <div>
        <v-text-field
                v-model="search"
                class="datatable-search"
                dense
                hide-details
                outlined
                prepend-inner-icon="mdi-magnify"/>
        <v-data-table
                :headers="header"
                :items="filteredItems"
                :loading="loading"
                :search="search"
                :item-class="getRowClass"
                sort-by="CreatedAt"
                sort-desc
                class="rounded-lg shadow my-6 history-table"
                @click:row="showDetails">
            <template v-slot:[`item.CreatedAt`]="{ item }">
                {{ formatDateTime(item.CreatedAt) }}
            </template>
            <template v-slot:[`item.Severity`]="{ item }">
                {{ getSeverity(item.Severity) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <span class="data-table-actions-column">
                <TableAction :tooltip="$t('tooltips.moreDetails')" icon="mdi-information"
                             @click="showDetails(item)"/>
                </span>
            </template>
            <template v-slot:[`header.Severity`]>
                <FilterDropDown
                        v-model="filters.severities"
                        :available-values="Array.from(availableValues.severities)"
                        :filter-values="severities"
                        :name="$t('notifications.severity')"/>
            </template>
        </v-data-table>
        <NotificationDetails :key="notificationID" :notification="notification" :notificationID="notificationID"
                             :open="openDetails" @close="openDetails = false"/>
    </div>
</template>

<script>
import {formatDateTime} from "@/helper/helper";
import {
  NOTIFICATIONS_SEVERITY_CRITICAL,
  NOTIFICATIONS_SEVERITY_INFO,
  NOTIFICATIONS_SEVERITY_WARNING
} from "@/helper/constants";
import NotificationDetails from "@/components/Notification/NotificationDetails";
import FilterDropDown from "@/components/reusable/FilterDropDown/FilterDropDown";

export default {
  name: "NotificationHistory",
  components: {FilterDropDown, NotificationDetails},
  mounted() {
    this.initNotifications();
  },
  data() {
    return {
      search: '',
      items: [],
      loading: false,
      filters: {
        severities: [],
      },
      availableValues: {
        severities: new Set(),
      },
      openDetails: false,
      notificationID: null,
      notification: {},
    };
  },
  computed: {
    unreadNotificationIDs() {
      return this.$store.getters.getUnreadNotificationIDs;
    },
    filteredItems() {
      return this.items.filter(item => this.filters.severities.includes(item.Severity));
    },
    header() {
      return [
        {text: this.$t('date'), value: 'CreatedAt'},
        {text: this.$t('notifications.title'), value: 'Title'},
        {text: this.$t('notifications.severity'), value: 'Severity'},
        {text: '', value: 'actions', class: 'data-table-actions-column', cellClass: 'data-table-actions-column', sortable: false, width: 200},
      ];
    },
    severities() {
      return [
        {
          text: this.$t('notifications.info'),
          value: NOTIFICATIONS_SEVERITY_INFO
        },
        {
          text: this.$t('notifications.warning'),
          value: NOTIFICATIONS_SEVERITY_WARNING
        },
        {
          text: this.$t('notifications.critical'),
          value: NOTIFICATIONS_SEVERITY_CRITICAL
        }
      ];
    },
  },
  methods: {
    formatDateTime,
    initNotifications() {
      const url = this.$store.getters.userNotifications;
      this.loading = true;
      this.axios.get(url).then(({data}) => {
        this.items = data.Result;
        this.items.forEach(item => {
          this.availableValues.severities.add(item.Severity);
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    getSeverity(severityID) {
      if (!severityID) {
        return '';
      }
      return this.severities.filter(severity => severity.value === severityID)[0].text;
    },
    showDetails(notification) {
      this.notification = notification;
      this.notificationID = notification.NotificationID;
      this.openDetails = true;
      if (this.unreadNotificationIDs.includes(notification.NotificationID)) {
        this.$store.dispatch('setNotificationViewed', notification.NotificationID)
      }
    },
    getRowClass(item) {
      if (this.unreadNotificationIDs.includes(item.NotificationID)) {
        return 'unread';
      }
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
@import "notification-history";
</style>